<template>
  <div>
    <v-alert
      text
      class="mt-5"
      :color="room.session && room.session.currentState === 'connected' && room.streams.list.length ? 'success' : 'primary'"
    >
      <div class="d-flex align-center">
        <div v-if="settings.icon.show" class="text-center pr-5">
          <v-avatar :color="room.session && room.session.currentState === 'connected' && room.streams.list.length ? 'success lighten-2' : 'primary lighten-2'">
            <Icon
              :width="24"
              :color="'#fff'"
              :icon="settings.icon.url"
            />
          </v-avatar>
        </div>
        <div
          v-if="room.session && room.session.currentState === 'connecting'"
        >
          <Loading :message="$t('sessionLink.lobby.loading')"/>
        </div>
        <div v-else-if="room.session && room.session.currentState === 'connected' && !room.streams.list.length">
          <h4>
            {{ settings.noCammer.message1 }}
          </h4>
          <h4 class="font-weight-regular">
            {{ settings.noCammer.message2 }}
          </h4>
        </div>
        <div v-else-if="room.session && room.session.currentState === 'connected' && room.streams.list.length">
          <h4>
            {{ settings.cammerWaiting.message1 }}
          </h4>
          <div
            v-if="params"
            class="text-right mt-2"
          >
            <v-btn
              color="primary"
              @click="$refs.confirm.toggleConfirm()"
              :loading="button.enter.loading"
              :disabled="button.enter.disabled"
              :dark="button.enter.disabled"
            >
              {{$t('sessionLink.lobby.cammerWaiting.action')}}
            </v-btn>
          </div>
        </div>
        <div v-else-if="room.session && room.session.currentState === 'disconnected'"></div>
      </div>
    </v-alert>
    <Confirm
      ref="confirm"
      :title="$t('sessionLink.lobby.confirm.title')"
      :detail="$t('sessionLink.lobby.confirm.detail')"
      :action="$t('sessionLink.lobby.confirm.action')"
      @confirmHandler="enterAttention"
    />
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
// require('@/socket')
require('@/plugins/OT')

@Component({
  components: {
    Loading: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Loading.vue'),
    Confirm: () => import(/* webpackPrefetch: true */ '@/components/Confirm.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    settings: {
      type: Object,
      default: null
    },
    session: {
      type: Object,
      default: null
    },
    organization: {
      type: Object,
      default: null
    },
    apiKeyVP8: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_VP8
    },
    apiKeyH264: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_H264
    }
  },
  watch: {
    'room.streams.list': function (list) {
      if (list.length) {
        this.enterAttention()
      }
    }
  },
  computed: {
    linkOfTheScheduledAppointment () {
      let href = this.session.siteUrl ? this.session.siteUrl : this.organization.hostName

      if (this.organization.linkOfTheScheduledAppointment) {
        href = this.organization.linkOfTheScheduledAppointment
      }

      return href
    }
  }
})
export default class Lobby extends Vue {
  data () {
    return {
      params: null,
      button: {
        enter: {
          loading: false,
          disabled: false
        }
      },
      room: {
        session: {
          currentState: 'connecting'
        },
        streams: {
          list: []
        }
      }
    }
  }

  mounted () {
    this.$socketEvents.connectListen()
    this.urlSearchParams()
    this.initRoom()
  }

  errorHandler (error) {
    console.log(error)
  }

  addStream (stream) {
    this.room.streams.list.push(stream)
  }

  removeStream (stream) {
    const index = this.room.streams.list.indexOf(stream)
    if (index > -1) {
      this.room.streams.list.splice(index, 1)
      this.room.session.unsubscribe(stream)
    }
  }

  async initRoom () {
    const apiKey = this.session.codec === 'H264' ? this.apiKeyH264 : this.apiKeyVP8
    this.room.session = OT.initSession(apiKey, this.session.tokboxId)

    this.room.session.connect((this.session.token), (error) => {
      if (error) {
        this.errorHandler(error)
      }
    })

    this.room.session.on('streamCreated', (event) => {
      this.addStream(event.stream)
    })

    this.room.session.on('streamDestroyed', (event) => {
      this.removeStream(event.stream)
    })

    this.room.session.on('sessionConnected', () => {
      this.notifyScheduledEvents()
    })
  }

  notifyScheduledEvents () {
    this.$socketEvents.scheduledEvents(this.session.agent.id)
  }

  toggleEnterButton () {
    this.button.enter.loading = !this.button.enter.loading
    this.button.enter.disabled = !this.button.enter.disabled
  }

  hasParamsUrl (url) {
    const urlObject = new URL(url)
    return urlObject.search !== ''
  }

  urlSearchParams() {
    const params = new URLSearchParams('')

    params.set('ocularSessionId', this.session.id)
    params.set('ocularOriginalUrl', this.linkOfTheScheduledAppointment)

    this.params = params.toString()

    return this.params
  }

  async enterAttention () {
    this.toggleEnterButton()
    this.urlSearchParams()

    if (this.$route.query.widgetMode) {
      this.room.session.disconnect()

      const session = {
        id: this.session.id
      }

      this.$storage.setStorageRoom(session)
      this.$storage.setState(4)

      this.$router.replace({ path: '/room' })
    } else {
      const url = this.linkOfTheScheduledAppointment
      const urlWithParams = this.hasParamsUrl(url)
      const symbol = urlWithParams ? '&' : '?'

      location.href = `${url}${symbol}${this.params}`
    }
  }
}
</script>
